<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { getPath } from '../../utils/imageKit.ts';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let { content, link, backgroundImage, lazyloadImage = false, dataTestId = 'more-info-banner' } = $props();

  // Handle Image Setup
  const moDefaultSrc = getPath(backgroundImage, { w: 188, h: 145 });
  const moHighResSrc = getPath(backgroundImage, { w: 188, h: 145 }, 2);
  const smDefaultSrc = getPath(backgroundImage, { w: 320, h: 109 });
  const smHighResSrc = getPath(backgroundImage, { w: 320, h: 109 }, 2);
  const mdDefaultSrc = getPath(backgroundImage, { w: 384, h: 174 });
  const mdHighResSrc = getPath(backgroundImage, { w: 384, h: 174 }, 2);
  const lgDefaultSrc = getPath(backgroundImage, { w: 496, h: 198 });
  const lgHighResSrc = getPath(backgroundImage, { w: 496, h: 198 }, 2);
  const xlDefaultSrc = getPath(backgroundImage, { w: 576, h: 198 });
  const xlHighResSrc = getPath(backgroundImage, { w: 576, h: 198 }, 2);
</script>

<div class="relative bg-blue-very-light lg:shadow-medium p-4 pb-5 lg:pb-7 lg:pl-10 lg:pt-8" data-testid={dataTestId}>
  <div class="relative w-2/3 z-10">
    <div class="text-blue-navy text-sm mb-4 md:text-1.5xl md:mb-4.5 max-w-136">
      {@html content}
    </div>
    <div class="text-blue-cerulean hover-hover:hover:text-blue-darkish active:text-blue-darkish cursor-pointer">
      <BaseLink className="text-sm font-semibold mr-2 hover-hover:hover:underline active:underline md:text-xl" {...link}>
        {link.text}
      </BaseLink>
      <svg class="inline-block w-3 h-3 fill-current lg:w-5 lg:h-5" role="presentation">
        <use xlink:href="{SPRITESHEET_URL}#right-arrow" />
      </svg>
    </div>
  </div>
  <div class="absolute top-0 right-0 botom-0 w-full z-0 h-full">
    <div class="h-full absolute top-0 right-0 bottom-0 left-0"></div>
    {#if backgroundImage && backgroundImage.url && backgroundImage.alt}
      <picture>
        <source media="(min-width: 1280px)" srcset={`${xlDefaultSrc}, ${xlHighResSrc} 2x`} />
        <source media="(min-width: 1024px)" srcset={`${lgDefaultSrc}, ${lgHighResSrc} 2x`} />
        <source media="(min-width: 768px)" srcset={`${mdDefaultSrc}, ${mdHighResSrc} 2x`} />
        <source media="(min-width: 640px)" srcset={`${smDefaultSrc}, ${smHighResSrc} 2x`} />
        <source media="(max-width: 639px)" srcset={`${moDefaultSrc}, ${moHighResSrc} 2x`} />
        <img
          class="h-full w-1/2 object-cover object-right ml-auto hidden sm:block"
          loading={lazyloadImage === true ? 'lazy' : 'eager'}
          height="145"
          width="188"
          src={moDefaultSrc}
          alt={backgroundImage.alt}
        />
      </picture>
    {/if}
  </div>
</div>
